<!--
 * @Description:
 * @Author: lijinpeng
 * @Date: 2024-04-16 16:15:26
 * @LastEditTime: 2024-05-18 11:19:20
 * @LastEditors: lijinpeng
-->
<template>
  <nf-confirm
    :show.sync="show"
    width="600px"
    title="获取验证码"
    :is-savel-btn="false"
    :is-cancel-btn="false"
    :handle-save-btn-click="handleSaveBtnClick"
    :handle-cancel-btn-click="handleCancelBtnClick"
  >
    <div slot="content" class="sms-content">
      <p class="sms-title">
        每月运单开票前需要获取经办人手机号
      </p>
      <div class="sms-form">
        <el-input v-model.trim="params.mobile" class="mobile" disabled>
          <i slot="prepend" class="el-icon-mobile-phone" />
        </el-input>
        <div class="code-wrap flex">
          <el-input v-model.trim="params.code" placeholder="验证码" maxlength="6" />
          <div style="width:118px;">
            <el-button
              type="text"
              :loading="codeLoading"
              :class="{ active: codeText !== '获取验证码' }"
              @click="handleMsgBtnClick"
            >
              {{ codeText }}
            </el-button>
          </div>
        </div>
        <div class="sms-content-footer">
          <span>手机号不在使用或经办人已变更？请</span>
          <el-button type="text" @click="handleJumpAgent">
            变更经办人
          </el-button>
          <el-button type="primary" size="mini" @click="handleSaveBtnClick">
            提交
          </el-button>
        </div>
      </div>
    </div>
  </nf-confirm>
</template>
<script>
import { valiPhone } from '@/utils/rules';
import { getETCAgent, getAgentSMSCode, postAgentSMSCodeValidate } from '@/api/agent';
import store from '@/store/index';

export default {
  name: 'AgentSMS',
  props: {
    // 是否显示
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 经办人信息
      agentInfo: {},
      // 表单数据
      params: {
        // 手机号
        mobile: '',
        // 验证码
        code: '',
        codeKey: '',
      },
      interval: null,
      // 验证码按钮loading
      codeLoading: false,
      // 获取验证码按钮内容
      codeText: '获取验证码',
      // 倒计时总秒数
      time: 60,
    };
  },
  computed: {
    corporationInfo() {
      return store.state.corporationInfo;
    },
    creator() {
      return store.state.creator;
    },
    admin() {
      return store.state.admin;
    },
    userInfo() {
      return store.state.headUser;
    },
  },
  async created() {
    let { code, data } = await getETCAgent({
      businessId: this.userInfo.uid.businessID,
    });
    if (code === 200) {
      this.agentInfo = data;
      this.params.mobile = data.mobile;
    }
  },
  methods: {
    // 验证经办人是否完善
    handleMsgBtnClick() {
      // agentHasComplete 经办人信息完备 1-完备 2-未完备
      if (this.agentInfo.agentHasComplete === 1) {
        this.handleGetAgentSMSCode();
      } else if (!this.creator || !this.admin) {
        this.$message({
          message:
            '请联系管理员' +
            this.corporationInfo.administrator +
            ':' +
            this.corporationInfo.administratorPhone +
            '完善经办人信息',
          type: 'warning',
        });
      } else {
        this.$confirm('请先完善经办人信息', '提示', {
          confirmButtonText: '去完善',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.handleJumpAgent();
          })
          .catch(() => {});
      }
    },
    // 获取验证码
    async handleGetAgentSMSCode() {
      if (this.codeText !== '获取验证码') return;

      if (!this.params.mobile) {
        return this.$$message('请输入手机号', 'warning');
      }
      if (!valiPhone(this.params.mobile)) {
        return this.$$message('手机号不合法', 'error');
      }
      this.codeLoading = true;
      try {
        const { code, data, msg } = await getAgentSMSCode({
          mobile: this.params.mobile,
          uid: this.userInfo.uid.uid,
          businessId: this.userInfo.uid.businessID,
        });
        if (code === 200) {
          this.codeLoading = false;
          this.$$message(msg, 'success');
          this.params.codeKey = data.codeKey;
        } else {
          this.codeLoading = false;
          return;
        }
        setTimeout(() => {
          this.codeLoading = false;
        }, 500);
      } catch (err) {
        this.$$message('获取手机验证码 失败：' + err, 'error');
        setTimeout(() => {
          this.codeLoading = false;
        }, 500);
        return;
      }

      if (this.interval) {
        clearInterval(this.interval);
      }

      this.codeText = this.time + '秒后获取';
      this.interval = setInterval(async () => {
        this.codeText = --this.time + '秒后获取';
        if (this.time <= 0) {
          clearInterval(this.interval);
          this.time = 60;
          this.codeText = '获取验证码';
        }
      }, 1000);
    },
    // 完善/变更经办人
    handleJumpAgent() {
      if (!this.creator || !this.admin) {
        this.$message({
          message:
            '请联系管理员' +
            this.corporationInfo.administrator +
            ':' +
            this.corporationInfo.administratorPhone +
            '变更经办人',
          type: 'warning',
        });
      } else {
        this.handleCancelBtnClick();
        window.open(window.location.origin + '/admin/agent/index');
      }
    },
    // 提交
    async handleSaveBtnClick() {
      if (!this.params.codeKey) {
        return this.$$message('请先获取验证码', 'warning');
      }
      if (!this.params.code) {
        return this.$$message('请输入验证码', 'warning');
      }
      try {
        const { code } = await postAgentSMSCodeValidate({
          code: this.params.code,
          codeKey: this.params.codeKey,
          businessId: this.userInfo.uid.businessID,
        });
        if (code === 200) {
          store.dispatch('getAgentSMSValidate');
          this.handleCancelBtnClick();
        }
      } catch (error) {
        console.error(error);
      }
    },
    // 取消
    handleCancelBtnClick() {
      this.$emit('cancel');
    },
  },
};
</script>
<style lang="scss" scoped>
.sms-content {
  .sms-title {
    color: rgb(217, 0, 27);
    text-align: center;
    margin-bottom: 30px;
  }
  .sms-form {
    width: 362px;
    margin: 0 auto;
  }
  .mobile {
    margin-bottom: 30px;
  }
  .code-wrap {
    align-items: center;
    margin-bottom: 60px;
    button {
      padding: 10px 20px;
      color: rgba(33, 84, 189, 1);
    }
    button.active {
      color: #787f95;
    }
  }
  &-footer {
    display: flex;
    justify-content: right;
    align-items: center;
  }
}
</style>
